import { render, staticRenderFns } from "./C-3-1a-4__ProductInfoEdit_Description.vue?vue&type=template&id=295c4e6d&"
import script from "./C-3-1a-4__ProductInfoEdit_Description.vue?vue&type=script&lang=js&"
export * from "./C-3-1a-4__ProductInfoEdit_Description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRadio,VRadioGroup,VTextField})
